<template>
  <q-banner
    v-if="!$_.isEmpty(order.errors)"
    class="bg-warning q-mb-md"
  >
    <template #avatar>
      <q-icon
        name="warning"
        color="negative"
      />
    </template>
    <template v-if="!$_.isEmpty(order.errors)">
      {{ order.errors[0] }}
    </template>
  </q-banner>
</template>

<script>
export default {
  name: 'OrderErrorBanner',
  props: {
    order: {
      type: Object,
      required: true
    }
  }
}
</script>
